import I2C from "i2c";


export default class BUS_I2C extends I2C {
  constructor(...args) {    
    super(...args);      
  }
  async initialize(...args) {
    this.open(...args);
  }  
  async update() {    
  }   
  get type() {
    return "bus";
  }
  toJSON() {
      return({
        type: this.type
      });
  }  
}